<div class="popup-overlay" *ngIf="show">
  <div class="popup-container">
    <div class="checkmark">&#10004;</div>
    <div class="title">{{popupData.title}}</div>
    <div class="pna-number">P&A No. {{popupData.pnaNo}}-{{popupData.pnaYear}}</div>
    <div class="message">{{popupData.message}}</div>
    <button class="close-button" (click)="closePopup()">Close</button>
  </div>
</div>
